import { useEffect, useSyncExternalStore } from "react";

import type { SourcingMeta } from "./api";

let pageMeta: SourcingMeta | null = null;
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getPageMeta() {
  return pageMeta;
}

export function setPageMeta(meta: SourcingMeta | null) {
  if (meta === pageMeta) return;
  pageMeta = meta;
  for (const listener of listeners) listener();
}

/** Publish the shown page's meta while it is mounted, so the shell age line describes this page (C11 B1). */
export function usePublishPageMeta(status: "pending" | "error" | "success", meta: SourcingMeta | null | undefined) {
  useEffect(() => {
    setPageMeta(status === "success" && meta ? meta : null);
    return () => setPageMeta(null);
  }, [status, meta]);
}

export function usePageMeta(): SourcingMeta | null {
  return useSyncExternalStore(subscribe, getPageMeta, getPageMeta);
}
